import React, { Component } from 'react';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import { FormattedMessage } from 'react-intl';

export class ConfigMenu extends Component {
  constructor (props) {
    super(props);
    this.state = {
      companyId: props.companyId,
    };
  }

  render () {
    return (
      <SideNav
        onSelect={(selected) => {
                    const to = '/config' + selected + (this.state.companyId ? '/' + this.state.companyId : '');
                    if (window.location.pathname !== to) {
                        this.props.history.push(to);
                    }
        }}
      >
        <SideNav.Toggle />
        <SideNav.Nav selected={this.props.selected}>
          <NavItem eventKey="company">
            <NavIcon>
              <i className="fa fa-fw fa-building sidenavimg" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
              <FormattedMessage id="company"/>
            </NavText>
          </NavItem>
          <NavItem eventKey="users">
            <NavIcon>
              <i className="fa fa-fw fa-users sidenavimg" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
              <FormattedMessage id="users"/>
            </NavText>
          </NavItem>
          <NavItem eventKey="services">
            <NavIcon>
              <i className="fa fa-fw fa-solid fa-list-alt sidenavimg" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
              <FormattedMessage id="services"/>
            </NavText>
          </NavItem>
          <NavItem eventKey="resources">
            <NavIcon>
              <i className="fa fa-fw fa-solid fa-bag-shopping sidenavimg" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
              <FormattedMessage id="resources"/>
            </NavText>
          </NavItem>
          <NavItem eventKey="calendar">
            <NavIcon>
              <i className="fa fa-fw fa-solid fa-calendar-days sidenavimg" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
              <FormattedMessage id="calendar"/>
            </NavText>
          </NavItem>
          <NavItem eventKey="params">
            <NavIcon>
              <i className="fa fa-fw fa-solid fa-sliders sidenavimg" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
              <FormattedMessage id="profiles"/>
            </NavText>
          </NavItem>
          <NavItem eventKey="charts">
            <NavIcon>
              <i className="fa fa-fw fa-line-chart sidenavimg" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
              <FormattedMessage id="charts"/>
            </NavText>
            <NavItem eventKey="charts/day">
              <NavText>
                <FormattedMessage id="day_chart"/>
              </NavText>
            </NavItem>
            <NavItem eventKey="charts/resource">
              <NavText>
                <FormattedMessage id="resource_chart"/>
              </NavText>
            </NavItem>
            <NavItem eventKey="charts/user">
              <NavText>
                <FormattedMessage id="user_chart"/>
              </NavText>
            </NavItem>
          </NavItem>
          <NavItem eventKey="qrcode">
            <NavIcon>
              <i className="fa fa-fw fa-solid fa-qrcode sidenavimg" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
              <FormattedMessage id="qrcode"/>
            </NavText>
          </NavItem>
        </SideNav.Nav>
      </SideNav>
    );
  }
}
